module.exports = __webpack_public_path__ + "media/images/choiz-logo-34296a7d7795c03361e2811eb4194845.png";